export const routesRandevu = [
  {
    path: "/randevu-list",
    name: "randevu-list",
    component: () => import("@/views/randevu/index.vue"),
    meta: {
      public: false,
      title: "randevu.Randevular",
      yetki: { k: [2000302] },
    },
  },
]
